<template>
  <v-card flat class="pa-2 response-summary">
    <h4 class="mb-2">Response summary:</h4>

    <div
      v-for="(result, rIndex) in response.results"
      :key="rIndex"
      class="mb-4"
    >
      <div class="mb-0 ml-4">
        <strong>Model:</strong> {{ result.model }}
        &nbsp;|&nbsp;
        <strong>Serial:</strong> {{ result.serial }}
      </div>

      <v-simple-table dense class="ml-4">
        <thead>
          <tr>
            <th>Document</th>
            <th>PDF</th>
            <th># Attachments</th>
            <th>Service grade</th>
            <th>Issue date</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(doc, dIndex) in result.documents"
            :key="dIndex"
          >
            <td>{{ doc.esvId }}</td>
            <td>{{ hasPdf(doc) }}</td>
            <td>{{ attachmentCount(doc) }}</td>
            <td>{{ serviceGrade(doc) }}</td>
            <td>{{ formatDate(doc.issueDate) }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "ResponseSummary",
  props: {
    response: {
      type: Object,
      required: true,
    },
  },
  methods: {
    hasPdf(doc) {
      return doc && doc.pdfLink ? "Yes" : "No";
    },
    attachmentCount(doc) {
      return doc && doc.attachmentLinks
        ? doc.attachmentLinks.length
        : 0;
    },
    serviceGrade(doc) {
      return doc && doc.serviceGrade !== undefined
        ? doc.serviceGrade
        : "-";
    },
    formatDate(date) {
      if (!date) return "-";
      return date.slice(0, 10);
    },
  },
};
</script>

<style scoped>
.response-summary {
  font-size: 12px;
  margin-left: 12px;
}

.response-summary h4 {
  font-size: 15px;
}
</style>